<template>
  <header id="main_header" class="column main_blue_dk_bg p0">
    <div class="columns m0_b p0_b container_header" v-if="!isMobile">
      <div class="column main_header_left">
        <router-link to="/home" class="dis_inb">
          <base-written-logo></base-written-logo>
        </router-link>
      </div>
      <div
        class="column main_header_right is-two-thirds tal_r"
        style="display: flex; justify-cotent: center; align-items: center; justify-content: end; width: auto;"
      >
        <ul>
          <li>
            <router-link to="/home" :class="{ active: route == 'home' }">{{
              $tc("msg.dashboard", 1) 
            }} </router-link>
          </li>

          <li @mouseleave="() => toggleServiceDrop()">
            <div
              class="pointer service-option-nav"
              :class="route == 'services' ? 'router-link-active' : ''"
              @mouseover="() => toggleServiceDrop()"
            >
              {{ $t("msg.services") }}
              <span
                v-if="toggleService"
                v-html="iconSets.general_arrow_down"
                class="icon_class_1"
                style="transform: rotate(180deg)"
              ></span>
              <span
                v-else
                v-html="iconSets.general_arrow_down"
                class="icon_class_1"
              ></span>
            </div>

            <div class="service-dropdown" v-if="toggleService">
              <div
                class="custom_flex_column m10_t pointer"
                @click="() => toggleServiceDrop()"
                v-for="servico in services"
                :key="servico.type"
              >
                <router-link
                  :to="servico.link"
                  style="text-decoration: none; color: white"
                >
                  <div class="custom_flex_row service-dropdown-item">
                    <span
                      v-html="iconSets[servico.icon_activated]"
                      class="icon_class_1"
                      v-if="checkParams(servico.type)"
                    ></span>
                    <span
                      v-html="iconSets[servico.icon]"
                      class="icon_class_1"
                      v-else
                    ></span>
                    <span style="margin-left: 10px">{{
                      $tc(`msg.${servico.type}`)
                    }}</span>
                  </div>
                </router-link>
              </div>
            </div>
          </li>

          <!-- <li>
            <router-link
              to="/pool"
              :class="route == 'pool' ? 'router-link-active' : ''"
              >{{ $tc("msg.pool", 1) }}</router-link
            >
          </li> -->

          <li>
            <router-link
              to="/transactions/deposits"
              :class="route == 'transactions' ? 'router-link-active' : ''"
              >{{ $tc("msg.transaction", 2) }}</router-link
            >
          </li>
          <li>
            <router-link to="/referrals">{{
              $tc("msg.referrals", 1)
            }}</router-link>
          </li>
          <li>
            <router-link to="/insights">{{ $t("msg.insights") }}</router-link>
          </li>
          <!-- <li>
            <a @click="showContact()">{{ $t("msg.contact") }}</a>
          </li> -->
          <li>
            <router-link to="/settings">{{ $t("msg.header_settings") }}</router-link>
          </li>
          <li>
            <a @click="logout()">{{ $tc("msg.logout", 1) }}</a>
          </li>
          <li>
            <base-language-bar></base-language-bar>
          </li>
        </ul>
      </div>
    </div>
    <!-- ............................................. -->
    <div v-else class="mobile_menu">
      <div v-if="openedMobileMenu" class="mobile_menu_opened">
        <div class="mobile_menu_opened_inner">
          <div class="column">
            <!-- <router-link to="home" class="dis_b combo_1 tal_c"> -->
              <div
                class="menu_icon_close main_white_fill"
                v-html="iconSets.general_close_2"
                @click="closeMobileMenu()"
              ></div>
            <!-- </router-link> -->
          </div>
          <div class="column">
            <ul class="combo_1">
              <li>
                <router-link
                  to="/home"
                  :class="{ active: route == 'home' }"
                  class="colorred"
                  >{{ $tc("msg.dashboard", 1) }}</router-link
                >
              </li>
              <li class="m2_t">
                <router-link to="/transactions/deposits">{{
                  $tc("msg.transaction", 2)
                }}</router-link>
              </li>
              <li class="m2_t">
                <router-link to="/referrals">{{
                  $tc("msg.referrals", 1)
                }}</router-link>
              </li>
              <li class="m2_t">
                <div
                  class="pointer service-option-nav"
                  :class="route == 'services' ? 'router-link-active' : ''"
                  @click="() => toggleServiceDrop()"
                  style="color: white"
                >
                  {{ $t("msg.services") }}
                  <span
                    v-if="toggleService"
                    v-html="iconSets.general_arrow_down"
                    class="icon_class_1 m9_l"
                    style="fill:white; color:white transform: rotate(90deg)"
                  ></span>
                  <span
                    v-else
                    v-html="iconSets.general_arrow_down"
                    class="icon_class_1 m9_l"
                    style="fill: white; color: white"
                  ></span>
                </div>
                <div class="service-dropdown-mobile" v-if="toggleService">
                  <div
                    class="custom_flex_column pointer"
                    @click="() => toggleServiceDrop()"
                    v-for="servico in services"
                    :key="servico.type"
                  >
                    <router-link
                      :to="servico.link"
                      style="text-decoration: none; color: white"
                    >
                      <div class="custom_flex_row service-dropdown-item">
                        <span
                          v-html="iconSets[servico.icon_activated]"
                          class="icon_class_1"
                          v-if="checkParams(servico.type)"
                        ></span>
                        <span
                          v-html="iconSets[servico.icon]"
                          class="icon_class_1"
                          v-else
                        ></span>
                        <span style="margin-left: 10px">{{
                          $tc(`msg.${servico.type}`)
                        }}</span>
                      </div>
                    </router-link>
                  </div>

                  <!-- <div
                    class="custom_flex_column m10_t pointer"
                    @click="() => toggleServiceDrop()"
                  >
                    <router-link
                      to="/services/deposit"
                      style="text-decoration: none; color: white"
                    >
                      <div class="custom_flex_row service-dropdown-item">
                        <span
                          v-html="iconSets.blu_deposit_icon"
                          class="icon_class_1"
                          style="color: white"
                        ></span>
                        <span style="margin-left: 10px">{{
                          $tc("msg.deposit")
                        }}</span>
                      </div>
                    </router-link>
                  </div>

                  <div
                    class="custom_flex_column m10_t pointer"
                    @click="() => toggleServiceDrop()"
                  >
                    <router-link
                      to="/services/withdraw"
                      style="text-decoration: none; color: white"
                    >
                      <div class="custom_flex_row service-dropdown-item">
                        <span
                          v-html="iconSets.blu_withdraw_icon"
                          class="icon_class_1"
                          style="color: white"
                        ></span>
                        <span style="margin-left: 10px">{{
                          $tc("msg.withdraw")
                        }}</span>
                      </div>
                    </router-link>
                  </div>

                  <div
                    class="custom_flex_column m10_t pointer"
                    @click="() => toggleServiceDrop()"
                  >
                    <router-link
                      to="/services/internal"
                      style="text-decoration: none; color: white"
                    >
                      <div class="custom_flex_row service-dropdown-item">
                        <span
                          v-html="iconSets.blu_redeem_icon"
                          class="icon_class_1"
                          style="color: white"
                        ></span>
                        <span style="margin-left: 10px; color: white">{{
                          $tc("msg.internal", 2)
                        }}</span>
                      </div>
                    </router-link>
                  </div>

                  <div
                    class="custom_flex_column m10_t pointer"
                    @click="() => toggleServiceDrop()"
                  >
                    <router-link
                      to="/services/redeem"
                      style="text-decoration: none; color: white"
                    >
                      <div class="custom_flex_row service-dropdown-item">
                        <span
                          v-html="iconSets.blu_redeem_icon"
                          class="icon_class_1"
                          style="color: white"
                        ></span>
                        <span style="margin-left: 10px; color: white">{{
                          $tc("msg.redeem", 2)
                        }}</span>
                      </div>
                    </router-link>
                  </div> -->
                </div>
              </li>
              <!-- <li class="m2_t">
                <router-link to="/pool">{{ $t("msg.pool") }}</router-link>
              </li> -->
              <li class="m2_t">
                <router-link to="/insights">{{
                  $t("msg.insights")
                }}</router-link>
              </li>
              <!-- <li class="m2_t">
                <a @click="showContact()">{{ $t("msg.contact") }}</a>
              </li> -->
              <li class="m2_t">
                <router-link to="/settings">{{ $t("msg.header_settings") }}</router-link>
              </li>
              <li class="m2_t">
                <a @click="logout()">{{ $tc("msg.logout", 1) }}</a>
              </li>
              <li class="m25_t">
                <base-language-bar></base-language-bar>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="columns is-mobile">
        <div class="column is-two-thirds">
          <router-link to="home" class="dis_b combo_1 tal_l">
            <base-written-logo style="width: 130px"></base-written-logo>
          </router-link>
        </div>
        <div class="column tal_r" style="display: flex; align-items: center">
          <div
            class="menu_icon main_white_fill"
            v-html="iconSets.general_menu"
            @click="openMobileMenu()"
          ></div>
        </div>
      </div>
    </div>
    <!-- ............................................. -->
    <!-- ............................................. -->
    <!-- ............................................. -->
    <!-- ............................................. -->

    <div class="column columns main_header_bottom m0 p0">
      <div class="column tal_l_b container_header" v-if="!banner">
        <div class="wrapper_user">
          <span v-if="member.role == 'adminREMOVETHISPARTSOITWORKS'">
            Welcome admin
          </span>
          <div v-else class="user_id_email">
            <div class="user_id">
              <span> {{ $tc("msg.user", 1) }} ID: </span>
              <span>{{ member.uid }} </span>
            </div>
            <span class="member_email">{{ member.email }}</span>
          </div>
        </div>

        <div class="live_price" v-if="bluValue">
          <div class="live_price_btn">
            <button></button>
            <p>{{ $t('msg.live_price') }}</p>
          </div>
          <p>{{ bluValue[0].value.toFixed(2) }} USDT</p>
        </div>
      </div>

      <web-banner v-if="banner"></web-banner>
    </div>
  </header>
</template>
<script>
import BaseLanguageBar from "./BaseLanguageBar";
import BluPricesHeader from "./BluPricesHeader";
import BaseWrittenLogo from "./BaseWrittenLogo.vue";
import WebBanner from "./WebBanner";

import Router from "vue-router";

import { mapGetters } from "vuex";
export default {
  created() {
    window.addEventListener("resize", this.checkIfMobile);
    this.getRoute();

    console.log(this.route);
  },
  mounted() {
    this.checkIfMobile();
  },
  data: () => ({
    fiveMinutesInMiliSeconds: 5 * 60 * 1000,
    isMobile: "",
    openedMobileMenu: false,
    route: "???",
    routeParams: "deposit",
    banner: false,
    toggleService: false,

    services: [
      {
        type: "deposit",
        link: "/services/deposit",
        icon: "blu_deposit_icon",
        icon_activated: "blu_deposit_icon_green",
      },
      {
        type: "withdraw",
        link: "/services/withdraw",
        icon: "blu_withdraw_icon",
        icon_activated: "blu_withdraw_icon_green",
      },
      {
        type: "internal",
        link: "/services/internal",
        icon: "internal_icon",
        icon_activated: "internal_icon_green",
      },
      {
        type: "redeem",
        link: "/services/redeem",
        icon: "blu_redeem_icon",
        icon_activated: "blu_redeem_icon_green",
      },
    ],
  }),
  components: {
    BluPricesHeader,
    BaseWrittenLogo,
    BaseLanguageBar,
    Router,
    WebBanner,
  },
  methods: {
    toggleServiceDrop() {
      this.toggleService = !this.toggleService;
    },

    checkParams(el) {
      if (this.$router.history.current.params) {
        if (this.$router.history.current.params.arg == el) {
          return true;
        }
      }
    },

    checkIfMobile() {
      let w = window,
        x = w.innerWidth;
      if (x > 1200) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    },
    openMobileMenu() {
      this.openedMobileMenu = true;
    },

    closeMobileMenu() {
      this.openedMobileMenu = false;
    },

    isActivatedDropItem() {},

    logout() {
      this.$store.dispatch("logout", "Logout");
      this.$router.push("login");
    },
    getRoute() {
      console.log("aquii");
      let current = this.$router.history.current.name;
      this.routeParams = this.$router.history.current.params.arg;
      this.route = current;
    },
    showContact() {
      this.$emit("showModal");
    },
  },
  computed: {
    ...mapGetters(["bluValue", "accounts", "currencies", "member"]),
  },
  watch: {
    $route(to, from) {
      this.getRoute();
      this.closeMobileMenu();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/public/BaseHeader.vue